module.exports = __webpack_public_path__ + "h5/img/statis2.32f3d469.png";